import React, { FC, useRef, useEffect } from 'react'
import { useDrag, useDrop } from 'react-dnd'
import TableRow from '@mui/material/TableRow'

const ItemType = 'AD_CREATIVE'

interface DraggableRowProps {
  id: string
  index: number
  moveRow: (from: number, to: number) => void
  children: React.ReactNode
}

const DraggableAdCreativeRow: FC<DraggableRowProps> = ({ id, index, moveRow, children }) => {
  const ref = useRef<HTMLTableRowElement>(null)
  const dragRef = useRef<HTMLDivElement>(null)

  const [, drop] = useDrop({
    accept: ItemType,
    drop(item: { id: string; index: number }) {
      if (!ref.current || item.index === index) return
      moveRow(item.index, index)
      item.index = index
    },
  })

  const [{ isDragging }, drag] = useDrag({
    type: ItemType,
    item: { id, index },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  })

  useEffect(() => {
    if (dragRef.current) {
      drag(dragRef)
    }
  }, [dragRef])

  drag(drop(ref))

  return (
    <TableRow ref={ref} hover sx={{ opacity: isDragging ? 0.5 : 1 }}>
      {React.Children.map(children, (child: any) => {
        if (child?.props?.children?.props?.['data-drag-handle-id'] === id) {
          return React.cloneElement(child, {
            ref: dragRef,
          })
        }
        return child
      })}
    </TableRow>
  )
}

export default DraggableAdCreativeRow
